import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { MainService } from './../_services/main.service';
import { FlashMessagesService } from 'angular2-flash-messages';
@Component({
  selector: 'app-phone-verification',
  templateUrl: './phone-verification.component.html',
  styleUrls: ['./phone-verification.component.scss']
})
export class PhoneVerificationComponent implements OnInit {
  sendOTPForm: FormGroup;
  verifyOTPForm: FormGroup;
  submitted = false;
  validFormat = true;
  otpSent = false;
  countDown = 0;
  timer = null;
  phoneNumber:any;
  constructor(
    private dialogRef: MatDialogRef<PhoneVerificationComponent>, 
    private spinner: NgxSpinnerService,
    private formBuilder: FormBuilder,
    public dialog: MatDialog,
    private _appService: MainService,
    private _flashMessagesService: FlashMessagesService,
    @Inject(MAT_DIALOG_DATA) private data) {
      this.phoneNumber = (data.phoneNumber != null) ? data.phoneNumber : '';
    }

  ngOnInit() {
    this.sendOTPForm = this.formBuilder.group({
      phone_number: [this.phoneNumber, [Validators.required,Validators.minLength(12),Validators.maxLength(12)]]
    });
    this.verifyOTPForm = this.formBuilder.group({
      phone_number: ['', [Validators.minLength(10),Validators.maxLength(12)]],
      otp: ['',Validators.required]
    });
    if(this.phoneNumber) {
      this.onSendOTPSubmit();
    }
  }
  // convenience getter for easy access to form fields
  get fSendOTP() { return this.sendOTPForm.controls; }

  get fVerifyOTP() { return this.verifyOTPForm.controls; }

  keyPress(event: any) {
    const pattern = /[0-9]/;
    const phonel:string = this.fSendOTP.phone_number.value; 
    const inputChar = String.fromCharCode(event.charCode);
    if ((event.keyCode !== 8 && !pattern.test(inputChar)) || phonel.length > 11) {
      event.preventDefault(); 
    }else{ 
      const countNumber = (this.fSendOTP.phone_number.value)?phonel.length:0; 
      if(countNumber === 3 || countNumber === 7){
        const phone_number = this.fSendOTP.phone_number.value+'-';
        this.fSendOTP['phone_number'].setValue(phone_number);
      }
    }
  }

  onSendOTPSubmit() {
    this.submitted = true;
    // stop here if form is invalid
    if (this.sendOTPForm.invalid) {
      return;
    } else {
      //Send OTP
      /**Add country code */
      const phone_number = '1%20'+this.sendOTPForm.value.phone_number.replace(/-/g, '');
      this.verifyOTPForm.controls['phone_number'].setValue(this.sendOTPForm.value.phone_number);
      this.spinner.show();
      this._appService.sendOTP(phone_number).subscribe((res: any) => {
        this.spinner.hide();
        this.submitted = false;
        if(res && res.status != null) {
          const alertClass = (res.status == 'success' || res.status == true) ? 'success' : 'danger';
          this._flashMessagesService.show(res.message, { cssClass: 'alert-'+ alertClass,timeout: 10000,showCloseBtn:true });
          if(res.status == 'success' || res.status == true) {
            this.otpSent = true;
            this.countDown = 60;
            this.getCountdown();
          }
        }
      });
    }
  }

  onVerifyOTPSubmit() {
    this.submitted = true;
    // stop here if form is invalid
    if (this.verifyOTPForm.invalid) {
      return;
    } else {
      //Verify OTP
      /**Add country code */
      const phone_number = '1%20'+this.verifyOTPForm.value.phone_number.replace(/-/g, '');
      const otp = this.verifyOTPForm.value.otp;
      this.spinner.show();
      this._appService.verifyOTP(phone_number, otp).subscribe((res: any) => {
        this.submitted = false;
        this.spinner.hide();
        if(res && res.status) {
          const alertClass = (res.status == 'success') ? 'success' : 'danger';
          this._flashMessagesService.show(res.message, { cssClass: 'alert-'+ alertClass,timeout: 10000,showCloseBtn:true });
          if(res.status == 'success') {
            setTimeout(() => {
              //Close the popup after successful verification
              this.dialogRef.close({verify_phone:'Y', primary_number: this.verifyOTPForm.value.phone_number});
            }, 2000);
          }
        }
      });
    }
  }

  getCountdown(){
    if(this.timer == null) {
      this.timer = setInterval(() => {
        this.countDown--;
        if(this.countDown == 0) {
          this.timer.clearInterval();
          this.timer = null;
        }
      }, 1000); 
    }
  }

  editPhoneNumber() {
    this.submitted = false;
    this.otpSent = false;
    if(this.timer != null) {
      this.timer.clearInterval();
      this.countDown = 0;
      this.timer = null;
    }
  }
}
